var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2255.09 1973.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8900f2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "csharp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1538.29,1515c-84.2,149.18-244.36,250.77-428.32,250.77-183,0-342.29-99.76-426.49-248-41.18-72.3-65-154.67-65-243.44,0-271.82,219.65-491.48,491.47-491.48,181.21,0,339.55,98.85,424.66,245.28L1963.87,781c-171.15-294.69-489.64-493.3-854.81-493.3-545.47,0-986.61,442.05-986.61,986.61,0,178.46,47.59,346.86,130.88,491.47,170.23,295.61,490.55,495.13,856.64,495.13,367,0,687.33-200.43,857.56-497.88ZM2081,1040.88h-97.92V1514H2081Zm216.91,0H2200V1514h97.93Z",
    transform: "translate(-122.45 -287.65)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2377.55,1120.5H1904.38v97.93h473.17Zm0,216H1904.38v97.93h473.17Z",
    transform: "translate(-122.45 -287.65)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharp);
export default __webpack_public_path__ + "static/media/csharp.1912b3246dcda8ae4e8567b5b323530e.svg";
export { ForwardRef as ReactComponent };